import { render, staticRenderFns } from "./EstatusCategoria.vue?vue&type=template&id=6a6b8e66&scoped=true"
import script from "./EstatusCategoria.vue?vue&type=script&lang=js"
export * from "./EstatusCategoria.vue?vue&type=script&lang=js"
import style0 from "./EstatusCategoria.vue?vue&type=style&index=0&id=6a6b8e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6b8e66",
  null
  
)

export default component.exports